{
  "version": 1,
  "asset_id": "70afbe9f-7a8c-4024-8e8a-bfeaa3e94764",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/70afbe9f-7a8c-4024-8e8a-bfeaa3e94764/gallery-8.jpeg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/70afbe9f-7a8c-4024-8e8a-bfeaa3e94764/gallery-8.jpeg",
  "original_filename": "gallery-8.jpeg",
  "size": 976153,
  "content_type": "image/jpeg",
  "created_at": "2026-07-01T04:21:36Z"
}
